import React, { FC, useState } from 'react'
import { Row, Col, Image } from 'react-bootstrap'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import RegisterForm from './RegisterForm'
import LoginLayout from '../layout'
import mavLogo from '../../../assets/img/gray_logo.svg'
import './styles.scss'

const Register: FC<RouteComponentProps> = ({ history }) => {
  const [isSubmitted, setIsSubmitted] = useState(false)

  return (
    <LoginLayout>
      <div className="register">
        <Image src={mavLogo} alt="Placeholder" className="logo-img" />
        {isSubmitted ? (
          <Row className="feedback">
            <Col>
              <h5>
                Thank you for your interest in Maverick. One of our Maverick team leads will be
                reaching out to you shortly to complete your registration process.
              </h5>
            </Col>
          </Row>
        ) : (
          <>
            <Row className="title">
              <Col>
                <h1>Glad to see you want to let your sales take off!</h1>
              </Col>
            </Row>
            <Row className="info">
              <Col>
                <p>Tell us a little about you and we will reach out with more.</p>
                <p>Information about MaverickApp&apos;s prospecting features.</p>
                <p>Get to know us better, follow us @themaverickapp in all the cool places.</p>
              </Col>
            </Row>
            <Row className="form">
              <Col>
                <RegisterForm setIsSubmitted={setIsSubmitted} />
                <button
                  className="link_btn"
                  onClick={(): void => history.push('/login')}
                  onKeyDown={(): void => {}}
                  type="button"
                >
                  Go Back
                </button>
              </Col>
            </Row>
          </>
        )}
      </div>
    </LoginLayout>
  )
}

export default withRouter(Register)
